// extracted by mini-css-extract-plugin
export var NavWrapper = "styles-module--NavWrapper--1s5Ru";
export var MainWrapper = "styles-module--MainWrapper--3AObK";